import React from 'react';
import SliderFieldStateContainer from './StateContainer';
import { BasicSliderSection, SliderDescription, StyledSlider } from './styles';

const SliderField = props => {
  const {
    id,
    nameType,
    max,
    values,
    formValid,
    logorthmic,
    trackColor,
    railColor,
    descriptionColor,
  } = props;

  let { min, value } = props;

  if (logorthmic && min < 1) {
    min = 0.49;
  }

  const scale = 1000 / Math.log(max);
  const minv = logorthmic ? Math.log(min) * scale : min;
  const maxv = logorthmic ? Math.log(max) * scale : max;

  const logToDec = x => Math.round(Math.exp(x / scale));

  const handleChange = newValue => {
    props.handleChange(id, logorthmic ? logToDec(newValue) : newValue);
  };

  value = value !== undefined ? value : values && values[id];

  return (
    <BasicSliderSection
      className={`st-slider-field${formValid[id] === -1 ? ' input-failed-value' : ''}`}
    >
      <SliderFieldStateContainer {...props} />
      <StyledSlider
        min={minv}
        max={maxv}
        trackColor={trackColor}
        railColor={railColor}
        value={logorthmic ? (value === 0 ? minv * 0.9 : Math.log(value) * scale) : value}
        onChange={handleChange}
        tipFormatter={v => value}
        id={id}
      />
      <SliderDescription
        className="st-slider-description"
        formValid={formValid}
        descriptionColor={descriptionColor}
      >
        {value} {nameType}
      </SliderDescription>
    </BasicSliderSection>
  );
};

SliderField.defaultProps = {
  descriptionColor: '#0076AD',
  trackColor: '#009de6',
  railColor: '#d3f1ff',
  logorthmic: false,
};

export default SliderField;
